
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ProfileButton } from "./ProfileButton";
import { useAuth } from "@/contexts/AuthContext";
import { MobileLandingMenu } from "./MobileLandingMenu";
import { useIsMobile } from "@/hooks/use-mobile";
import { BookOpen, BookIcon } from "lucide-react";
import { useState } from "react";
import { DemoRequestDialog } from "@/components/landing/DemoRequestDialog";

export function EmployerLandingNav() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const [demoDialogOpen, setDemoDialogOpen] = useState(false);

  const menuItems: any[] = [];

  return (
    <div className="w-full flex items-center justify-end space-x-4">
      {isMobile ? (
        <MobileLandingMenu items={menuItems} />
      ) : (
        <>
          {menuItems.map((item, index) => (
            <Button 
              key={index}
              variant="ghost" 
              className="text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200"
              onClick={item.onClick}
            >
              {item.label}
            </Button>
          ))}
        </>
      )}
      
      {user ? (
        <ProfileButton />
      ) : (
        <div className={`flex ${isMobile ? "gap-2" : "gap-3"}`}>
          <Button 
            variant="default"
            onClick={() => setDemoDialogOpen(true)}
            className={`bg-secondary hover:bg-secondary-hover text-secondary-foreground rounded-sm ${isMobile ? "text-xs px-2 py-1 h-auto" : ""}`}
          >
            Book a Demo
          </Button>
          <Button 
            variant="outline"
            onClick={() => navigate("/signup")}
            className={`bg-primary hover:bg-primary-hover text-primary-foreground rounded-sm ${isMobile ? "text-xs px-2 py-1 h-auto" : ""}`}
          >
            Get Started
          </Button>
        </div>
      )}

      {/* Demo Request Dialog */}
      <DemoRequestDialog open={demoDialogOpen} onOpenChange={setDemoDialogOpen} />
    </div>
  );
}
